var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{staticClass:"cardData",class:{
    [_vm.$style.cardItem]: true,
    [_vm.$style.cardItemActive]: _vm.active === parseInt(_vm.dataCard.id),
  },on:{"click":_vm.onClickCard}},[_c('div',{class:_vm.$style.content},[_c('img',{attrs:{"src":require(`@/assets/store/add-store/${_vm.dataCard.logo}`)}})]),_c('div',{class:_vm.$style.footer},[_c('span',[_vm._v(_vm._s(_vm.dataCard.name))]),(_vm.dataCard.status === 'coming soon')?_c('span',{class:_vm.$style.coming_soon},[_vm._v(_vm._s(_vm.$t('add_store.coming_soon')))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }